/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateRealizationUnitRequestDto } from '../models';
// @ts-ignore
import type { RealizationUnitDto } from '../models';
// @ts-ignore
import type { RealizationUnitIdDto } from '../models';
// @ts-ignore
import type { RealizationUnitSearchRequestDto } from '../models';
// @ts-ignore
import type { RealizationUnitsSearchResponseDto } from '../models';
// @ts-ignore
import type { UpdateRealizationUnitRequestDto } from '../models';
/**
 * RestRealizationUnitsApi - axios parameter creator
 */
export const RestRealizationUnitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateRealizationUnitRequestDto} createRealizationUnitRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRealizationUnit: async (createRealizationUnitRequestDto: CreateRealizationUnitRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRealizationUnitRequestDto' is not null or undefined
            assertParamExists('createRealizationUnit', 'createRealizationUnitRequestDto', createRealizationUnitRequestDto)
            const localVarPath = `/api/realization-units`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRealizationUnitRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} realizationUnitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRealizationUnit: async (realizationUnitId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'realizationUnitId' is not null or undefined
            assertParamExists('getRealizationUnit', 'realizationUnitId', realizationUnitId)
            const localVarPath = `/api/realization-units/{realizationUnitId}`
                .replace('{realizationUnitId}', encodeURIComponent(String(realizationUnitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of realization units
         * @param {number} page 
         * @param {number} pageSize 
         * @param {RealizationUnitSearchRequestDto} realizationUnitSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRealizationUnits: async (page: number, pageSize: number, realizationUnitSearchRequestDto: RealizationUnitSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchRealizationUnits', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchRealizationUnits', 'pageSize', pageSize)
            // verify required parameter 'realizationUnitSearchRequestDto' is not null or undefined
            assertParamExists('searchRealizationUnits', 'realizationUnitSearchRequestDto', realizationUnitSearchRequestDto)
            const localVarPath = `/api/realization-units/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(realizationUnitSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} realizationUnitId 
         * @param {UpdateRealizationUnitRequestDto} updateRealizationUnitRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRealizationUnit: async (realizationUnitId: number, updateRealizationUnitRequestDto: UpdateRealizationUnitRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'realizationUnitId' is not null or undefined
            assertParamExists('updateRealizationUnit', 'realizationUnitId', realizationUnitId)
            // verify required parameter 'updateRealizationUnitRequestDto' is not null or undefined
            assertParamExists('updateRealizationUnit', 'updateRealizationUnitRequestDto', updateRealizationUnitRequestDto)
            const localVarPath = `/api/realization-units/{realizationUnitId}`
                .replace('{realizationUnitId}', encodeURIComponent(String(realizationUnitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRealizationUnitRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestRealizationUnitsApi - functional programming interface
 */
export const RestRealizationUnitsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestRealizationUnitsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateRealizationUnitRequestDto} createRealizationUnitRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRealizationUnit(createRealizationUnitRequestDto: CreateRealizationUnitRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RealizationUnitIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRealizationUnit(createRealizationUnitRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRealizationUnitsApi.createRealizationUnit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} realizationUnitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRealizationUnit(realizationUnitId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RealizationUnitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRealizationUnit(realizationUnitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRealizationUnitsApi.getRealizationUnit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of realization units
         * @param {number} page 
         * @param {number} pageSize 
         * @param {RealizationUnitSearchRequestDto} realizationUnitSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchRealizationUnits(page: number, pageSize: number, realizationUnitSearchRequestDto: RealizationUnitSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RealizationUnitsSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchRealizationUnits(page, pageSize, realizationUnitSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRealizationUnitsApi.searchRealizationUnits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} realizationUnitId 
         * @param {UpdateRealizationUnitRequestDto} updateRealizationUnitRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRealizationUnit(realizationUnitId: number, updateRealizationUnitRequestDto: UpdateRealizationUnitRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRealizationUnit(realizationUnitId, updateRealizationUnitRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRealizationUnitsApi.updateRealizationUnit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestRealizationUnitsApi - factory interface
 */
export const RestRealizationUnitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestRealizationUnitsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateRealizationUnitRequestDto} createRealizationUnitRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRealizationUnit(createRealizationUnitRequestDto: CreateRealizationUnitRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RealizationUnitIdDto> {
            return localVarFp.createRealizationUnit(createRealizationUnitRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} realizationUnitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRealizationUnit(realizationUnitId: number, options?: RawAxiosRequestConfig): AxiosPromise<RealizationUnitDto> {
            return localVarFp.getRealizationUnit(realizationUnitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of realization units
         * @param {number} page 
         * @param {number} pageSize 
         * @param {RealizationUnitSearchRequestDto} realizationUnitSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRealizationUnits(page: number, pageSize: number, realizationUnitSearchRequestDto: RealizationUnitSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RealizationUnitsSearchResponseDto> {
            return localVarFp.searchRealizationUnits(page, pageSize, realizationUnitSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} realizationUnitId 
         * @param {UpdateRealizationUnitRequestDto} updateRealizationUnitRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRealizationUnit(realizationUnitId: number, updateRealizationUnitRequestDto: UpdateRealizationUnitRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateRealizationUnit(realizationUnitId, updateRealizationUnitRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestRealizationUnitsApi - interface
 */
export interface RestRealizationUnitsApiInterface {
    /**
     * 
     * @param {CreateRealizationUnitRequestDto} createRealizationUnitRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRealizationUnit(createRealizationUnitRequestDto: CreateRealizationUnitRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RealizationUnitIdDto>;

    /**
     * 
     * @param {number} realizationUnitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRealizationUnit(realizationUnitId: number, options?: RawAxiosRequestConfig): AxiosPromise<RealizationUnitDto>;

    /**
     * 
     * @summary Get list of realization units
     * @param {number} page 
     * @param {number} pageSize 
     * @param {RealizationUnitSearchRequestDto} realizationUnitSearchRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchRealizationUnits(page: number, pageSize: number, realizationUnitSearchRequestDto: RealizationUnitSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RealizationUnitsSearchResponseDto>;

    /**
     * 
     * @param {number} realizationUnitId 
     * @param {UpdateRealizationUnitRequestDto} updateRealizationUnitRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRealizationUnit(realizationUnitId: number, updateRealizationUnitRequestDto: UpdateRealizationUnitRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestRealizationUnitsApi - object-oriented interface
 */
export class RestRealizationUnitsApi extends BaseAPI implements RestRealizationUnitsApiInterface {
    /**
     * 
     * @param {CreateRealizationUnitRequestDto} createRealizationUnitRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createRealizationUnit(createRealizationUnitRequestDto: CreateRealizationUnitRequestDto, options?: RawAxiosRequestConfig) {
        return RestRealizationUnitsApiFp(this.configuration).createRealizationUnit(createRealizationUnitRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} realizationUnitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRealizationUnit(realizationUnitId: number, options?: RawAxiosRequestConfig) {
        return RestRealizationUnitsApiFp(this.configuration).getRealizationUnit(realizationUnitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of realization units
     * @param {number} page 
     * @param {number} pageSize 
     * @param {RealizationUnitSearchRequestDto} realizationUnitSearchRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchRealizationUnits(page: number, pageSize: number, realizationUnitSearchRequestDto: RealizationUnitSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestRealizationUnitsApiFp(this.configuration).searchRealizationUnits(page, pageSize, realizationUnitSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} realizationUnitId 
     * @param {UpdateRealizationUnitRequestDto} updateRealizationUnitRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateRealizationUnit(realizationUnitId: number, updateRealizationUnitRequestDto: UpdateRealizationUnitRequestDto, options?: RawAxiosRequestConfig) {
        return RestRealizationUnitsApiFp(this.configuration).updateRealizationUnit(realizationUnitId, updateRealizationUnitRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

